import { render, staticRenderFns } from "./_ToolbarActions.vue?vue&type=template&id=5820ecc1&scoped=true&"
import script from "./_ToolbarActions.vue?vue&type=script&lang=js&"
export * from "./_ToolbarActions.vue?vue&type=script&lang=js&"
import style0 from "./_ToolbarActions.vue?vue&type=style&index=0&id=5820ecc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820ecc1",
  null
  
)

export default component.exports